import { Box, Button, Divider, InputLabel, TextField, Typography } from '@mui/material';
import React from 'react';
import useI18n from '../../../hooks/useI18n';
import useUserInfo from '../../../hooks/useUserInfo';
import BasicModal from '../../custom/Modal/BasicModal';
import PhoneInput from '../../custom/PhoneInput/PhoneInput';
import cabinetSettingsService from '../../../api/cabinetSettings';

function UserSetting() {
    const { l, language } = useI18n();
    const { user, getCurrentUser } = useUserInfo();
    const [open, setOpen] = React.useState(false);
    const [userSetting, setUserSetting] = React.useState();
    const [recSettings, setRecSettings] = React.useState({ rec_min_confidence: '', rec_per_item_limit: '', rec_name_similarity_threshold: '' });
    const [recSaved, setRecSaved] = React.useState(false);

    const isWebtest = user?.CODE === 'WEBTEST';

    React.useEffect(() => {
        const currentUser = getCurrentUser();
        setUserSetting(currentUser);
    }, []);

    React.useEffect(() => {
        if (!isWebtest) return;
        cabinetSettingsService.getSettings()
            .then(s => setRecSettings({ rec_min_confidence: s.rec_min_confidence, rec_per_item_limit: s.rec_per_item_limit, rec_name_similarity_threshold: s.rec_name_similarity_threshold }))
            .catch(err => console.error('Failed to load cabinet settings:', err));
    }, [isWebtest]);

    const handleSubmit = async (event) => {
        event.preventDefault();
    }

    const handleOnChange = (event) => {}

    const handleRecSave = async () => {
        try {
            const saved = await cabinetSettingsService.updateSettings({
                rec_min_confidence:            parseFloat(recSettings.rec_min_confidence),
                rec_per_item_limit:            parseInt(recSettings.rec_per_item_limit),
                rec_name_similarity_threshold: parseFloat(recSettings.rec_name_similarity_threshold),
            });
            setRecSettings({ rec_min_confidence: saved.rec_min_confidence, rec_per_item_limit: saved.rec_per_item_limit, rec_name_similarity_threshold: saved.rec_name_similarity_threshold });
            setRecSaved(true);
            setTimeout(() => setRecSaved(false), 2000);
        } catch (err) {
            console.error('Failed to save rec settings:', err);
        }
    };

    return (userSetting ?
        <Box
            component={'form'}
            onSubmit={handleSubmit}
            margin={'0 auto'}
            padding={2}
            borderRadius={2}
            sx={{ backgroundColor: 'white' }}>
            {open ?
                <BasicModal isOpened={true}
                    type="warning"
                    title={l('Warning')}
                    text={l('Phone number is required') + '!'}
                    handle={() => setOpen(false)}
                /> : ""
            }
            <Typography component="h2" variant="h5">{l('User setting')}</Typography>
            <Divider />
            <Box sx={{ margin: '10px 0', width: '50%' }}>
                <InputLabel htmlFor="email">{l('Email')}</InputLabel>
                <TextField name="email"
                    id="email"
                    defaultValue={userSetting?.EMAIL}
                    variant="outlined"
                    size="small"
                    autoComplete='off'
                    fullWidth
                    disabled='true'
                />
                <PhoneInput value={userSetting?.PHONE} name="phoneNumber" handleChange={handleOnChange} disabled='true' />
            </Box>

            {/*<Box display={'flex'} flexWrap={'wrap'} gap={1}>
                <FormGroup>
                    <FormControlLabel checked={userSetting?.alarm_to_mail} onChange={handleOnChange} name='alarm_to_mail' control={<Switch />} label={l("Alarm to mail")} />
                    <FormControlLabel checked={userSetting?.alarm_to_sms} onChange={handleOnChange} name='alarm_to_sms' control={<Switch />} label={l("Alarm to SMS")} />
                </FormGroup>
            </Box>*/}
            <Button sx={{ mt: 2, display: 'flex', flexGrow: 1 }} style={{ backgroundColor: '#F0B21C' }} type="submit" size="small" variant="contained">{l('Save')}</Button>

            {isWebtest && (
                <Box sx={{ mt: 3 }}>
                    <Divider />
                    <Typography component="h2" variant="h6" sx={{ mt: 2, mb: 1 }}>Recommendations settings</Typography>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, width: '50%' }}>
                        <Box>
                            <InputLabel>Min confidence (REC_MIN_CONFIDENCE)</InputLabel>
                            <TextField
                                type="number"
                                size="small"
                                fullWidth
                                inputProps={{ step: 0.01, min: 0, max: 1 }}
                                value={recSettings.rec_min_confidence}
                                onChange={e => setRecSettings(s => ({ ...s, rec_min_confidence: e.target.value }))}
                            />
                        </Box>
                        <Box>
                            <InputLabel>Per item limit (REC_PER_ITEM_LIMIT)</InputLabel>
                            <TextField
                                type="number"
                                size="small"
                                fullWidth
                                inputProps={{ step: 1, min: 1 }}
                                value={recSettings.rec_per_item_limit}
                                onChange={e => setRecSettings(s => ({ ...s, rec_per_item_limit: e.target.value }))}
                            />
                        </Box>
                        <Box>
                            <InputLabel>Name similarity filter (REC_NAME_SIMILARITY_THRESHOLD)</InputLabel>
                            <TextField
                                type="number"
                                size="small"
                                fullWidth
                                inputProps={{ step: 0.01, min: 0, max: 1 }}
                                value={recSettings.rec_name_similarity_threshold}
                                onChange={e => setRecSettings(s => ({ ...s, rec_name_similarity_threshold: e.target.value }))}
                            />
                        </Box>
                        <Button
                            size="small"
                            variant="contained"
                            style={{ backgroundColor: recSaved ? '#4caf50' : '#1565c0', width: 'fit-content' }}
                            onClick={handleRecSave}
                        >
                            {recSaved ? 'Saved!' : 'Save recommendations settings'}
                        </Button>
                    </Box>
                </Box>
            )}
        </Box> : '');
}

export default UserSetting;